import FindPasswordForm from "components/auth/FindPasswordForm";
import React from "react";
import useUserDetailQuery from "features/user/hooks/queries/useUserDetailQuery";
import { Navigate } from "react-router-dom";
import { ROUTER_PATH } from "config/path";
import styled, { css } from "styled-components";

const AuthFindPasswordPage = () => {
  /* 로그인 시 리다이렉트 */
  const { data: currentUser } = useUserDetailQuery();

  if (!!currentUser) {
    return <Navigate to={ROUTER_PATH.home} replace />;
  }

  return (
    <>
      <DescriptionStyle>
        <h1>비밀번호 찾기</h1>
        <p>
          회원가입 시 등록한 이메일을 입력해 주시면
          <br />
          해당 이메일로 임시 비밀번호를 발송해 드립니다.
        </p>
      </DescriptionStyle>
      <FindPasswordForm />
    </>
  );
};

export default AuthFindPasswordPage;

/* Styles */
export const Wrap = styled.div`
  display: flex;
`;

export const DescriptionStyle = styled.div`
  margin: 7.6rem 0 5.8rem 0;

  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.6rem;

  h1 {
    font-size: 3.6rem;
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
  }

  p {
    ${({ theme }) => theme.typography.body1.regular}
    color: ${({ theme }) => theme.color.text.secondary};
    text-align: center;
  }

  ${({ theme }) => css`
    ${theme.media.small} {
      margin-top: 12.9rem;
      gap: 1.4rem;

      h1 {
        font-size: 2.4rem;
        font-weight: 700;
        line-height: 3.6rem; /* 150% */
        letter-spacing: -0.072rem;
      }

      p {
        ${theme.typography.body3.regular}
        letter-spacing: -0.042rem;
      }
    }
  `}
`;
